import React from "react";

const ErrorMessage = ({ text }: { text: string | undefined }) => {
    return <div className={"text-sm text-error m-2"}> {text || ""}</div>;
};

export default ErrorMessage;
